import { useCallback } from "react";

import { useLocalization } from "@plex/culture-react";

import { IMessageId, ILocalizable } from "infrastructure/localization";

export const isMessageId = (message: IMessageId | ILocalizable): message is IMessageId => {
  return !!message && "value" in message;
};

// return standard function that should be use to localize data of IMessageId or ILocalizable types
export function useLocalizer() {
  const { t } = useLocalization();

  const localizer = useCallback((key: IMessageId, tokens?: {} | undefined) => t(key.value, tokens), [t]);

  return localizer;
}
